import * as components from './components'

export default [
  {
    path: '/discover',
    component: components.Results,
    name: 'results',
    props: true
  },
  {
    path: '/job/board',
    component: components.JobBoard,
    name: 'jobBoard',
    props: true
  },
  {
    path: '/employer/board',
    component: components.EmployerBoard,
    name: 'employerBoard',
    props: true
  },
  {
    path: '/employer/institutions',
    component: components.ManageEmployerInstitutions,
    name: 'manageEmployerInstitutions',
    props: true
  },
  {
    path: '/manage/jobs',
    component: components.ManageJobs,
    name: 'manageJobs',
    props: true
  },
  {
    path: '/manage/institution-employers',
    component: components.ManageInstitutionEmployers,
    name: 'manageInstitutionEmployers',
    props: true
  },
  {
    path: '/manage/all-employers',
    component: components.ManageAllEmployers,
    name: 'manageAllEmployers',
    props: true
  },
  {
    path: '/employer/admin',
    component: components.ManageJobs,
    name: 'employerAdmin',
    props: true
  },
  {
    path: '/search/course',
    component: components.CourseSearch,
    name: 'courseSearch',
    props: true
  },
  {
    path: '/search/result',
    component: components.Results,
    name: 'tagSearchResults',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/search/routes.js